import { useFetch } from '../../hooks/useFetch';

export const FetchDashboardTrends = async (params) => {
  const body = await useFetch(`${process.env.REACT_APP_API_URL}/dashboard/trends`, params);

  return body.data;
};
